module.exports = __webpack_public_path__ + "static/media/mashya_thumb_wide.e41b79f6.webp";